import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { testid: "nav-link-radio", label: "A Rádio", to: "/#radio" },
  { testid: "nav-link-sets", label: "Sets", to: "/#sets" },
  { testid: "nav-link-agenda", label: "Agenda", to: "/#agenda" },
  { testid: "nav-link-blog", label: "Blog", to: "/blog" },
  { testid: "nav-link-contato", label: "Contato", to: "/#contato" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#08090C]/80 border-b border-[#232638]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
        <Link to="/" data-testid="nav-brand-logo" className="flex items-baseline gap-2" onClick={() => setOpen(false)}>
          <span className="font-display text-xl font-extrabold uppercase tracking-tighter">Ronaldo</span>
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-400">DJ</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <Link
              key={l.testid}
              to={l.to}
              data-testid={l.testid}
              className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-amber-400 transition-colors duration-300"
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <button
          data-testid="nav-mobile-menu-button"
          className="md:hidden text-zinc-300"
          onClick={() => setOpen(!open)}
          aria-label="Abrir menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="md:hidden overflow-hidden border-t border-[#232638]"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <Link
                  key={l.testid}
                  to={l.to}
                  data-testid={`${l.testid}-mobile`}
                  onClick={() => setOpen(false)}
                  className="font-display text-lg font-bold uppercase tracking-tight text-zinc-200 hover:text-amber-400 transition-colors"
                >
                  {l.label}
                </Link>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
